import PageTitle from './PageTitle-compose';

export default PageTitle;
